import { Button, Grid, Icon } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import React from 'react'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'

export const EditCell = ({ id }) => {
  const pathGen = useGeneratePathI18n()

  return (
    <Grid gap={16} justifyContent={'end'}>
      {
        <Button
          component={Link}
          to={pathGen(ROUTES.REFERRAL_LINKS_EDIT, { linkId: id })}
          variant={'ghost'}
          size={'l'}
          startIcon={<Icon name="settings" color={'Interface-Eighth'} />}
        />
      }
    </Grid>
  )
}

EditCell.propTypes = {
  id: PropTypes.number,
}
